import { render, staticRenderFns } from "./StepMain.vue?vue&type=template&id=13f7bc6e&scoped=true&"
import script from "./StepMain.vue?vue&type=script&lang=js&"
export * from "./StepMain.vue?vue&type=script&lang=js&"
import style0 from "./StepMain.vue?vue&type=style&index=0&id=13f7bc6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f7bc6e",
  null
  
)

export default component.exports